import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { LOGIN } from "../../routes";
import { Smartphone } from "lucide-react";
import { PasswordResetRequest } from "../../Services/loginService";
import { loginpage } from "../../Assets";

const ResetPasswordRequestPage = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const validationSchema = Yup.object().shape({
    mobile: Yup.string()
      .matches(/^\d{10}$/, "Enter a valid 10-digit mobile number")
      .required("Mobile number is required"),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    setLoading(true);
    try {
      const response = await PasswordResetRequest(values);
      toast.success(response.data.message || "Check your email for reset link!");
      setSubmitting(false);
      navigate(LOGIN);
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Failed to request password reset"
      );
      setSubmitting(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center md:justify-end relative">
      {/* Background image if needed */}
      <div className="absolute inset-0 opacity-80 bg-cover bg-center" style={{ backgroundImage: `url(${loginpage})` }} />

      <div className="flex flex-col md:mr-24 gap-8 items-center relative z-10">
        <p className="text-white z-50 text-5xl md:text-8xl font-bold">
          {process.env.REACT_APP_TITLE}
        </p>

        <div className="bg-white/40 backdrop-blur-md p-8 rounded-2xl shadow-lg w-full max-w-md">
          <div className="flex flex-col items-center mb-4">
            <p className="text-center text-2xl text-primary mt-4 font-semibold">
              Reset Password
            </p>
          </div>

          <Formik
            initialValues={{ mobile: "", email: "" }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting }) => (
              <Form className="flex flex-col gap-4 w-full text-green" autoComplete="off">
                {/* Mobile Number */}
                <div className="relative w-full">
                  <Smartphone className="absolute top-3 left-3 text-gray-400" />
                  <Field
                    name="mobile"
                    type="tel"
                    placeholder="Mobile Number"
                    className="w-full border rounded py-3 pl-10 px-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                  <ErrorMessage
                    name="mobile"
                    component="p"
                    className="text-red-500 text-xs italic mt-1"
                  />
                </div>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full flex justify-center items-center bg-primary text-white p-2 rounded hover:bg-blue-700"
                >
                  {isSubmitting ? "Submitting..." : "Send Reset Link"}
                </button>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordRequestPage;
